module.exports = __webpack_public_path__ + "static/sqr-8455104ff4a6977657990852d57d9e28.png";